import * as React from "react";
import { memo } from "react";
const SvgLeftArrow = (props) => (
  <svg
    width={13}
    height={12}
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.125 6C0.125 5.7066 0.362849 5.46875 0.65625 5.46875H12.3438C12.6372 5.46875 12.875 5.7066 12.875 6C12.875 6.2934 12.6372 6.53125 12.3438 6.53125H0.65625C0.362849 6.53125 0.125 6.2934 0.125 6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.81315 0.8431C6.02062 1.05057 6.02062 1.38693 5.81315 1.5944L1.40755 6L5.81315 10.4056C6.02062 10.6131 6.02062 10.9494 5.81315 11.1569C5.60568 11.3644 5.26932 11.3644 5.06185 11.1569L0.2806 6.37565C0.0731335 6.16818 0.0731335 5.83182 0.2806 5.62435L5.06185 0.8431C5.26932 0.635633 5.60568 0.635633 5.81315 0.8431Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.125 6C0.125 5.7066 0.362849 5.46875 0.65625 5.46875H12.3438C12.6372 5.46875 12.875 5.7066 12.875 6C12.875 6.2934 12.6372 6.53125 12.3438 6.53125H0.65625C0.362849 6.53125 0.125 6.2934 0.125 6Z"
      stroke="currentColor"
      strokeWidth={0.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.81315 0.8431C6.02062 1.05057 6.02062 1.38693 5.81315 1.5944L1.40755 6L5.81315 10.4056C6.02062 10.6131 6.02062 10.9494 5.81315 11.1569C5.60568 11.3644 5.26932 11.3644 5.06185 11.1569L0.2806 6.37565C0.0731335 6.16818 0.0731335 5.83182 0.2806 5.62435L5.06185 0.8431C5.26932 0.635633 5.60568 0.635633 5.81315 0.8431Z"
      stroke="currentColor"
      strokeWidth={0.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Memo = memo(SvgLeftArrow);
export default Memo;

